import BadgeIcon from '@mui/icons-material/Badge'
import LeadsList from './LeadsList'

export default {
  list: LeadsList,
  icon: BadgeIcon,
  recordRepresentation: 'fullName',
}
